import React from 'react';
import {createRoot} from 'react-dom/client';
import {BrowserRouter} from 'react-router';

import '../InitSentry';
import {PostHogAnalyticsProvider} from '../PostHogAnalytics';
import DarkModeThemeProvider from '../DarkModeThemeProvider';
import {AuthProvider} from '../Auth/AuthProvider';
import {ViewportProvider} from '../ViewportProvider';
import {appBasename} from '../Util/compassApp';
import App from './App';

// Load our global styles
import '../css/index.css';

import axios from 'axios';

const container = document.getElementById('arc-pro-app');
const root = createRoot(container);
axios.defaults.withCredentials = true;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
root.render(
  <PostHogAnalyticsProvider>
    <DarkModeThemeProvider ignoreLocalStorage={true}>
      <BrowserRouter basename={appBasename()}>
        <AuthProvider>
          <ViewportProvider>
            <App />
          </ViewportProvider>
        </AuthProvider>
      </BrowserRouter>
    </DarkModeThemeProvider>
  </PostHogAnalyticsProvider>
);
